import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { getData, sendDataBody } from '../../resources'
import Loading from '../../loading'
import { Col, Row, Select, Button } from 'antd'
import Expedientes from '../../doctorViews/expedientes/expedientes'
import { RegisterModal } from '../patients/register.user'
import { EditOutlined, PlusOutlined } from '@ant-design/icons'

const { Option } = Select;

export default function PacientesNext({ id_hospital }) {

    const { state } = useLocation()
    const name_from_state = state?.name ?? null

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalEditOpen, setIsModalEditOpen] = useState(false)

    const [pacientes, setPacientes] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [paciente, setPaciente] = useState(null)
    const idmedsRef = useRef([])
    const initialPacientesRef = useRef([])

    useEffect(() => {
        getPacientes()
    }, [])

    const getPacientes = async () => {
        const meds = await getData(`users/hospital/${id_hospital}`)
        const idmeds = meds.map(doc => doc._id)
        idmedsRef.current = idmeds

        const endpoint = name_from_state ? 'pacientes/medicos/search/name' : 'pacientes/medicos/first'
        const body = name_from_state ? { medicos: idmeds, search: name_from_state } : { medicos: idmeds }
        sendDataBody(endpoint, body).then((rs) => {
            initialPacientesRef.current = rs
            setPacientes(rs)
            if (!paciente) setPaciente(rs[0])
            setIsLoading(false)
        })
    }

    const onChange = (data) => {
        const found = pacientes.find(p => p._id === data)
        setPaciente(found)
    }

    const onSearch = (value) => {
        if (!value) {
            setPacientes(initialPacientesRef.current)
            return
        }
        sendDataBody('pacientes/medicos/search/name', { medicos: idmedsRef.current, search: value })
            .then(rs => setPacientes(rs))
    }

    if (isLoading) return <Loading />

    return (
        <div>
            <Row justify="start" align="middle" style={{ marginBottom: 16 }} wrap>
                <Col>
                    <Select
                        style={{ borderRadius: 8, width: 380 }}
                        dropdownStyle={{ borderRadius: 8 }}
                        showSearch
                        placeholder="Buscar paciente"
                        onChange={onChange}
                        onSearch={onSearch}
                        filterOption={false}
                        value={paciente?._id}
                    >
                        {pacientes.map(p => <Option key={p._id} value={p._id}>{p.name}</Option>)}
                    </Select>
                </Col>
                <Col style={{ marginLeft: 12 }}>
                    <Button
                        className='btnIconCentered'
                        style={{ height: 30, marginRight: 12 }}
                        onClick={() => setIsModalEditOpen(true)}
                        size='small'
                        icon={<EditOutlined />}
                        shape='round'
                        type="primary"
                        ghost
                        disabled={!paciente}
                    >
                        Editar Paciente
                    </Button>
                    <Button
                        className='btnIconCentered'
                        style={{ height: 30 }}
                        onClick={() => setIsModalOpen(true)}
                        size='small'
                        icon={<PlusOutlined />}
                        shape='round'
                        type="primary"
                    >
                        Registrar Paciente
                    </Button>
                </Col>
            </Row>

            {paciente
                ? <Expedientes paciente={paciente} setIsEditModalOpen={setIsModalEditOpen} />
                : <div>No hay paciente seleccionado</div>
            }

            <RegisterModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} paciente={null} getPacientesData={getPacientes} />
            <RegisterModal isModalOpen={isModalEditOpen} setIsModalOpen={setIsModalEditOpen} paciente={paciente} getPacientesData={getPacientes} />
        </div>
    )
}
